import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>{".cls-151{fill:#060b0c;stroke-width:0}"}</style>
    </defs>
    <g id="Palette">
      <circle
        cx={24}
        cy={24}
        r={24}
        style={{
          fill: "#00a4b7",
          strokeWidth: 0,
        }}
      />
      <path
        d="M24 17c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2a9 9 0 1 0 .001 18.001A9 9 0 0 0 24 15Z"
        className="cls-151"
      />
      <path
        d="M24.01 14c6.1 0 11.76 3.63 15.67 10-3.92 6.37-9.58 10-15.67 10S12.24 30.37 8.32 24c3.92-6.37 9.58-10 15.69-10m0-2C16.64 12 10.11 16.71 6 24c4.1 7.29 10.64 12 18.01 12S37.9 31.29 42 24c-4.1-7.29-10.64-12-17.99-12Z"
        className="cls-151"
      />
    </g>
  </svg>
)
export default SvgComponent
